export const MESSAGES_QUERY_LIMIT = 50;
export const MESSAGES_SORT_DIRECTION = 'DESC';
export const AVAILABLE_SCROLL_HEIGHT_TO_TOP = 300;
